// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__B9EIq","label":"Completed_label__PAC2X"};